export default __webpack_public_path__ + "static/media/mobile-asset1.13eb8bdd.png";